import React, { Component } from 'react';
import { isEmpty, isFinite } from 'lodash';
import ReusableTransformBannerActions from 'js/components/reusableTransforms/ReusableTransformBannerActions/ReusableTransformBannerActions';
import ReusableTransformsTable from 'js/components/reusableTransforms/ReusableTransformsTable';
import { ACL_RESOURCE_TYPE_TRANSFORM } from 'js/constants/aclConstants';
import { CONTACT_SUPPORT_LINK } from 'js/constants/config';
import {
  RESOURCE_TYPE_ATTR_TRANSFORM,
  RESOURCE_TYPE_RECORD_TRANSFORM,
} from 'js/constants/resourceTypes';
import { SUPPORT_KEY_REUSABLE_TX } from 'js/constants/supportPageKeys';
import { SearchFilterTypes, SearchFilterViews } from 'js/constants/visibilityFilters';
import { TransformType } from 'new/components/ReusableTransform/types';
import { ResourceActivity } from 'new/elements/support/detailTabs/ResourceActivity';
import NoContentTextView from '../elements/NoContentTextView';
import AclTabViewContainer from '../elements/aclView/AclTabViewContainer';
import './ViewReusableTransforms.scss';
import ReusableTxOverviewTabContainer from './cards/ReusableTxOverviewTabContainer';

const description =
  'Easily manage custom code transformations for multiple Nexsets. Add Attribute Transforms to define attribute creation rules or Record Transforms to define record creation rules.';

const availableFilterTypes = [
  SearchFilterTypes.ID,
  SearchFilterTypes.NAME,
  SearchFilterTypes.DESCRIPTION,
  SearchFilterTypes.TAG,
];

class ViewReusableTransforms extends Component {
  componentDidMount() {
    this.props.setContextualSupport(SUPPORT_KEY_REUSABLE_TX);
  }

  componentWillUnmount() {
    this.props.unsetContextualSupport(SUPPORT_KEY_REUSABLE_TX);
  }

  _handleEditTxClicked = (tx) => {
    this.props.onFormLoadButtonClicked(tx);
  };

  _handleCreateTxClicked = () => {
    this.props.onFormLoadButtonClicked(null, this.props.listingTransformType);
  };

  render() {
    const {
      data,
      onlyTableView,
      isLoading,
      transformId,
      selectedCardData,
      listingTransformType,
      getReusableTransformListing,
    } = this.props;
    const detailViewTabs = [
      {
        tabName: 'Overview',
        tabElement: <ReusableTxOverviewTabContainer />,
      },
    ];

    if (selectedCardData) {
      const resourceType =
        selectedCardData.output_type === TransformType.ATTRIBUTE
          ? RESOURCE_TYPE_ATTR_TRANSFORM
          : RESOURCE_TYPE_RECORD_TRANSFORM;

      detailViewTabs.push({
        tabName: 'Activity',
        tabElement: <ResourceActivity resourceType={resourceType} data={{}} />,
      });
    }

    detailViewTabs.push({
      tabName: 'Access',
      tabElement: <AclTabViewContainer resourceType={ACL_RESOURCE_TYPE_TRANSFORM} />,
    });

    const singleItemMode = isFinite(transformId);

    let noContentView = null;

    if (isLoading === false && (!data || isEmpty(data))) {
      if (singleItemMode) {
        noContentView = (
          <NoContentTextView
            title={<div>We are sorry, we could not find this transform.</div>}
            subtitle={
              <div>
                Please reload the page or file a{' '}
                <a style={{ color: '#507fe7' }} href={CONTACT_SUPPORT_LINK}>
                  support ticket
                </a>{' '}
                to request support.
              </div>
            }
          />
        );
      } else {
        noContentView = (
          <NoContentTextView
            title={<div>Looks empty here. Try creating a transform in the button above</div>}
          />
        );
      }
    }

    return (
      <>
        <ReusableTransformBannerActions
          transformID={transformId}
          onSubmit={this._handleCreateTxClicked}
        />
        <ReusableTransformsTable
          key={listingTransformType}
          view={SearchFilterViews.REUSABLE_TRANSFORMS}
          urlId={transformId}
          isLoading={isLoading}
          data={data}
          detailViewTabs={detailViewTabs}
          availableFilterTypes={availableFilterTypes}
          noContentView={noContentView}
          loadData={getReusableTransformListing}
          onEditButtonClicked={this._handleEditTxClicked}
        />
      </>
    );
  }
}

ViewReusableTransforms.defaultProps = {
  withHeader: true,
};

export default ViewReusableTransforms;
